import { createSelector } from 'reselect';
import { getSelectorRoot } from 'utils/selectors';

const getBetSlip = getSelectorRoot('betSlip');

const getCounterOffers = getBetSlip('counterOffers');
const getSentSuperBetCount = getBetSlip('sentSuperBetCount');
const getOddsCounterOffers = getBetSlip('oddsCounterOffers');
const getSentCounterOffersCount = getBetSlip('sentCounterOffersCount');
const getCounterOffersUnderReviewModal = getBetSlip(
  'counterOfferUnderReviewModal'
);

const getSelectedOddCounterOffer = getBetSlip('selectedOddCounterOffer');
const getSelectedCounterOfferType = getBetSlip('counterOfferSelectedType');
const getIsCounterOfferActive = createSelector(
  [getCounterOffers],
  counterOffers => Object.values(counterOffers).some(({ isActive }) => isActive)
);

export {
  getCounterOffers,
  getSentSuperBetCount,
  getOddsCounterOffers,
  getCounterOffersUnderReviewModal,
  getIsCounterOfferActive,
  getSentCounterOffersCount,
  getSelectedOddCounterOffer,
  getSelectedCounterOfferType
};
